import { PageShell } from '@/components/ui/PageShell';
import { EliteCard } from '@/components/ui/EliteCard';
import { PrimaryButton, SecondaryButton } from '@/components/ui/Buttons';
import { db } from '@/lib/db/db';
import { useLiveQuery } from 'dexie-react-hooks';
import { useAuthStore } from '@/store/authStore';
import { useNavigate } from 'react-router-dom';
import { UserPlus, Shield } from 'lucide-react';

export function AthleteListPage() {
    const { account } = useAuthStore();
    const navigate = useNavigate();

    // In a pure Supabase app, we'd fetch from supabase.
    // For this MVP mixed mode, we fetch local athletes created by this account.
    const athletes = useLiveQuery(() =>
        account ? db.athletes.where('accountId').equals(account.id).toArray() : []
    ) || [];

    return (
        <PageShell title="My Athletes" subtitle="Parent Dashboard">
            <div className="space-y-6 animate-fade-in-up">

                <div className="flex justify-end">
                    <PrimaryButton className="py-2.5 px-4 text-xs">
                        + Add Athlete
                    </PrimaryButton>
                </div>

                <div className="grid gap-4">
                    {athletes.length === 0 ? (
                        <div className="text-center py-12 text-text-muted text-sm border border-white/5 rounded-2xl bg-bg-surface/50">
                            You haven't added any athletes yet.
                        </div>
                    ) : (
                        athletes.map(athlete => (
                            <EliteCard key={athlete.id} className="p-5 flex flex-col gap-4">
                                <div className="flex items-center gap-4">
                                    <div className="w-14 h-14 rounded-full bg-white/5 flex items-center justify-center text-2xl border border-white/10">
                                        {athlete.avatar || '🤼'}
                                    </div>
                                    <div className="flex-1">
                                        <h3 className="text-white font-black text-lg">{athlete.name}</h3>
                                        <p className="text-[11px] text-text-muted uppercase tracking-widest font-bold">
                                            {athlete.level} • {athlete.experienceYears} Years Exp
                                        </p>
                                    </div>
                                </div>
                                <div className="flex gap-2 pt-2 border-t border-white/5">
                                    <SecondaryButton
                                        onClick={() => navigate(`/athletes/${athlete.id}/share`)}
                                        className="flex-1 text-[10px] py-2 flex items-center justify-center gap-1.5"
                                    >
                                        <UserPlus size={14} /> Invite Coach
                                    </SecondaryButton>
                                    <SecondaryButton
                                        onClick={() => navigate(`/athletes/${athlete.id}/visibility`)}
                                        className="flex-1 text-[10px] py-2 flex items-center justify-center gap-1.5 border-white/10 text-white hover:border-gold-500/50 hover:text-gold-400"
                                    >
                                        <Shield size={14} /> Privacy
                                    </SecondaryButton>
                                </div>
                            </EliteCard>
                        ))
                    )}
                </div>
            </div>
        </PageShell>
    );
}
